import { flex } from 'hfty-styles/src/mixins'

export const styles = {
  loaderWrapper: {
    ...flex(),
    width: '100%',
    padding: '50px 0',
  },
}
